export const EXPORT_UNDER_OVER_DEPRECIATION_REPORT_REQUEST = 'EXPORT_UNDER_OVER_DEPRECIATION_REPORT_REQUEST'
export const EXPORT_UNDER_OVER_DEPRECIATION_REPORT_FAILURE = 'EXPORT_UNDER_OVER_DEPRECIATION_REPORT_FAILURE'
export const EXPORT_UNDER_OVER_DEPRECIATION_REPORT_SUCCESS = 'EXPORT_UNDER_OVER_DEPRECIATION_REPORT_SUCCESS'
